import { useEffect, useRef, useState } from "react";
import { useGoogleMapsScript } from "../../../useScript";
import { Flex } from "../../Common/Flex";
import ExternalImageSelect from "../ExternalImageSelect";

const photoUrlOptions: google.maps.places.PhotoOptions = {
    maxWidth: 1200,
    maxHeight: 1200,
};
type GoogleImageSelectorProps = {
    googlePlaceId: string;
    initialValues: string[];
    onSelect: (urls: string[]) => void;
};

function GoogleImageSelector(props: GoogleImageSelectorProps) {
    const { googlePlaceId, initialValues, onSelect } = props;
    const [photos, setPhotos] = useState<google.maps.places.PlacePhoto[]>();
    const googlePlacesRef = useRef<HTMLDivElement>(null);
    const scriptLoadStatus = useGoogleMapsScript();

    useEffect(() => {
        function loadPlace(id: string, ref: HTMLDivElement) {
            if (window.google && ref) {
                const service = new google.maps.places.PlacesService(ref);
                const request = {
                    placeId: id,
                    fields: ["photos"],
                };
                service.getDetails(request, (googlePlace) => {
                    if (googlePlace) {
                        setPhotos(googlePlace.photos);
                    }
                });
            }
        }

        if (googlePlaceId && scriptLoadStatus === "ready" && googlePlacesRef.current) {
            loadPlace(googlePlaceId, googlePlacesRef.current);
        }
    }, [googlePlaceId, scriptLoadStatus, googlePlacesRef]);

    return (
        <Flex.Column gap="medium">
            <div ref={googlePlacesRef} />
            <ExternalImageSelect
                allUrls={(photos || []).map((photo) => photo.getUrl(photoUrlOptions))}
                initialUrlSelections={initialValues}
                onSelect={(selected) => {
                    onSelect(selected);
                }}
            />
        </Flex.Column>
    );
}

export default GoogleImageSelector;
